import axios from "axios";
import React from "react";
import { baseUrl, mainBaseUrl } from "../../App";

const RejectButton = ({ eventID, isRejected, getInfo }) => {
  const [Load, setLoad] = React.useState(false);
  const rejectCertificate = () => {
    setLoad(true);
    var config = {
      method: "post",
      url: `${mainBaseUrl}/rejectCertificates/${eventID}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };
    if (isRejected === false) {
      axios(config)
        .then((response) => console.log(response.data))
        .then(() => {
          getInfo();
          setLoad(false);
        });
    } else {
      setLoad(false);
      alert("Certificate is already rejected");
    }
  };
  return (
    <button onClick={rejectCertificate} className="adminButton" type="submit">
      {Load ? "Loading.." : isRejected ? "Rejected" : "Reject"}
    </button>
  );
};

export default RejectButton;
